var React = require('react');

function MapMarkerGray (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M768 512q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm256 0q0 109-33 179l-364 774q-16 33-47.5 52t-67.5 19-67.5-19-46.5-52L33 691Q0 621 0 512q0-212 150-362T512 0t362 150 150 362z","fill":"#abb8b2","key":0}),React.createElement("rect",{"x":"0","y":"0","width":"1024","height":"1536","fill":"rgba(0, 0, 0, 0)","key":1})]);
}

MapMarkerGray.defaultProps = {"width":"1024","height":"1536","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 1024 1536"};

module.exports = MapMarkerGray;

MapMarkerGray.default = MapMarkerGray;
